var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"we-editor",class:_vm.editorName})
}
var staticRenderFns = []

export { render, staticRenderFns }